import React from 'react';
import { formatCurrency } from '../../utlis/formatCurrency';
import { numberToWordsIndian } from '../../utlis/numberToWordsIndian';

const SummaryBankRow = ({ 
  bank, 
  totals, 
  formatCurrency,
  paidAmount = 0,
  onPaidAmountChange = () => {},
  isEditable = false,
  showPaymentFields = true,
  amountInWords
}) => {
  const handlePaidAmountChange = (e) => {
    const value = parseFloat(e.target.value) || 0;
    const validatedValue = Math.min(value, totals.total);
    onPaidAmountChange(validatedValue);
  };

  const balanceDue = totals.total - paidAmount;

  return (
    <div className="summary-bank-row">
      <div className="bank-details">
        <h4>Bank Details</h4>
        <p><strong>Bank:</strong> {bank.name}</p>
        <p><strong>Account No:</strong> {bank.accountNo}</p>
        <p><strong>Account Type:</strong> {bank.accountType}</p>
        <p><strong>IFSC:</strong> {bank.ifsc}</p>
      </div>
      <div className="summary">
        <p><strong>Taxable Value:</strong> {formatCurrency(totals.taxable)}</p>
        <p><strong>CGST:</strong> {formatCurrency(totals.cgst)}</p>
        <p><strong>SGST:</strong> {formatCurrency(totals.sgst)}</p>
        <p><strong>IGST:</strong> {formatCurrency(totals.igst)}</p>
        <p><strong>Total Amount:</strong> {formatCurrency(totals.total)}</p>
        
        {/* Payment Fields - Only show if showPaymentFields is true */}
        {showPaymentFields && (
          <>
            <p className="paid-amount-row">
              <strong>Paid Amount:</strong>
              {isEditable ? (
                <input
                  type="number"
                  min="0"
                  max={totals.total}
                  step="0.01"
                  value={paidAmount}
                  onChange={handlePaidAmountChange}
                  className="paid-amount-input"
                />
              ) : (
                <span className="paid-amount-display">
                  {formatCurrency(paidAmount)}
                </span>
              )}
            </p>
            
            <p className="balance-due-row">
              <strong>Balance Due:</strong>
              <span className="balance-due-amount">
                {formatCurrency(balanceDue)}
              </span>
            </p>
          </>
        )}
        
        {/* Amount in words - Show different label based on invoice type */}
        <p className="amount-in-words">
          <strong>{showPaymentFields ? 'Balance Due in words:' : 'Total in words:'}</strong> 
          <span> {amountInWords} only</span>
        </p>
      </div>
    </div>
  );
};

export default SummaryBankRow;